// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import InfoOutlineSvg from '@rsuite/icon-font/lib/status/InfoOutline';
var InfoOutline = createSvgIcon({
  as: InfoOutlineSvg,
  ariaLabel: 'info outline',
  category: 'status',
  displayName: 'InfoOutline'
});
export default InfoOutline;